export enum FormPolicy {
    Anonymous,
    Collect,
    All
}
